module.exports = __webpack_public_path__ + "media/images/front/robles_center-12e719fc355ea46788760438985f866c.webp";